/*@ngInject*/
const UIFormTooltipDirective = function ($document, $timeout, submissionConstant, coreConstant, $sanitize) {

    let linkFunction = function ($scope, $elm, $attr) {

        let timeoutList = [],
            body = angular.element('body'),
            formViewer = angular.element('.formViewer .formViewerContainer:first-child'),
            tooltip,
            arrow,
            arrowBackground;

        function showTooltip(componentParams) {

            let tooltipConfig = componentParams.fieldStructure.dynamicProperties.tooltip;

            if (componentParams.tooltipMessage && tooltipConfig.type !== 'errorPopover') {
                tooltipConfig.message = componentParams.tooltipMessage;
            }

            let hasTooltipMessage = tooltipConfig && tooltipConfig.message,
                showTooltipDelay = tooltipConfig ? tooltipConfig.delay : 0,
                activeElement = $document[0].activeElement,
                hasFocus = activeElement ? activeElement.className === $elm[0].className : false,
                shouldAddTooltip = !tooltip && hasTooltipMessage && !hasFocus;// && isEnabled;

            if (shouldAddTooltip) {

                body.append(
                    '<div class="uiTooltip ' + tooltipConfig.type + '">' +
                    '<div class="message">' + $sanitize(tooltipConfig.message) + '</div>' +
                    '<div class="arrowBackground"></div>' +
                    '<div class="arrow"></div>' +
                    '</div>');
                tooltip = angular.element('.uiTooltip');
                arrow = angular.element('.arrow');
                arrowBackground = angular.element('.arrowBackground');
                tooltip.css('opacity', 0);
                tooltip.css('top', componentParams.pageY - ((tooltip[0].offsetHeight + componentParams.offsetY) + 1));
                if (tooltip[0].offsetWidth > componentParams.clientWidth) {
                    tooltip.css('left', componentParams.pageX - (componentParams.offsetX + (tooltip[0].offsetWidth - componentParams.clientWidth) / 2));
                } else {
                    tooltip.css('left', (componentParams.pageX + (componentParams.clientWidth - tooltip[0].offsetWidth) / 2) - componentParams.offsetX);
                }

                formViewer.on('scroll', removeTooltip);
                $scope.$on('$stateChangeStart', removeTooltip);
                $scope.$on(submissionConstant.event.CLEAR_VISIBLE_TOOLTIP, removeTooltip);

                timeoutList.push($timeout(function () {
                    if (tooltip) {
                        tooltip.css('opacity', 1);
                    }
                }, showTooltipDelay));
            }
        }

        function removeTooltip() {
            if (!_.isNil(tooltip)) {
                tooltip.css('opacity', 0);
                formViewer.off('scroll', removeTooltip);
                angular.element('.uiTooltip').remove();
                tooltip = null;
            }
        }

        $scope.$on(coreConstant.event.SHOW_FORM_TOOLTIP, function (arg1, params) {
            showTooltip(params);
        });

        $scope.$on(coreConstant.event.HIDE_FORM_TOOLTIP, function () {
            removeTooltip();
        });

        $scope.$on('$destroy', function () {
            if (!_.isNil(tooltip)) {
                formViewer.off('scroll', removeTooltip);
                angular.element('.uiTooltip').remove();
                tooltip = null;
            }

            _.each(timeoutList, function (item) {
                $timeout.cancel(item);
            });
        });
    };

    return {
        restrict: 'E',
        link: linkFunction
    };
};

angular.module('umFormViewer')
    .directive('uiFormTooltip', UIFormTooltipDirective);
